import LegalLanguagePopUp from 'components/LegalLanguagePopUp';
import React from 'react';
import {View} from 'native-base';
import {useTheme} from 'styled-components/native';
import {
  openURL,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useSelector} from 'Provider';
import {allowNewTermsScreenSelector} from 'store/target/target.selectors';

const AcceptTermsScreen = () => {
  const theme = useTheme() as any;
  const {ghostWhite} = theme.colors;
  const isWeb = useIsWeb();
  const allowTermsScreen =
    useSelector(allowNewTermsScreenSelector) ||
    (isWeb &&
      (location.hostname === 'localhost' || window.isLegacyMyRewards)) ||
    !isWeb ||
    window.tests.includes('allow-new-terms-screen');

  if (!allowTermsScreen) {
    // Redirect to home screen
    openURL('/rewards/home');
    return null;
  }

  return (
    <View
      flex={1}
      justifyContent="center"
      alignItems="center"
      backgroundColor={ghostWhite}>
      <LegalLanguagePopUp />
    </View>
  );
};

export default AcceptTermsScreen;
